import { FC, useState } from "react";
import { Flex } from "@chakra-ui/react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

// react-pdf 11 ships an ESM-only pdf.js, so the worker is resolved out of the bundle
// instead of being pulled from a CDN (which no longer serves a matching `.js` build).
pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.mjs", import.meta.url).toString();

interface PdfViewProps {
  file: string;
}

const PdfView: FC<PdfViewProps> = ({ file }) => {
  const [numPages, setNumPages] = useState<number | null>(null);

  return (
    <Flex justifyContent="center">
      <Document file={file} onLoadSuccess={({ numPages }) => setNumPages(numPages)}>
        {Array(numPages)
          .fill(0)
          .map((_, i) => (
            <Page key={i} pageNumber={i + 1} scale={1.4} renderTextLayer={false} />
          ))}
      </Document>
    </Flex>
  );
};

export default PdfView;
